import {
  AfterViewInit,
  Component,
  ElementRef,
  NgZone,
  ViewChild
} from '@angular/core';

import { config } from 'app/app.config';
import { AskQuestionService } from 'app/bot/ask-question.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.scss'],
  standalone: false
})
export class MapsComponent implements AfterViewInit {

  @ViewChild('usaSvg')
  usaSvg!: ElementRef<HTMLObjectElement>;

  hoverState = '';
  selectedState = '';

  stateDocuments: any[] = [];
  selectedDocument: any = null;

  isDocumentsLoading = false;

  selectedStateCode = '';
  hoveredStateCode = '';

  offset = config.DEFAULT_OFFSET;
  Record_limit = config.DEFAULT_RECORD_LIMIT;
  search = '';

  company_id: any;
  user_id: any;

  documentCounts: Record<string, number> = {};

  isSelectFileType: any = "";
  selectedReadFile: any = "";

  private readonly stateCodes = [
    'AL', 'AK', 'AZ', 'AR', 'CA',
    'CO', 'CT', 'DE', 'FL', 'GA',
    'HI', 'ID', 'IL', 'IN', 'IA',
    'KS', 'KY', 'LA', 'ME', 'MD',
    'MA', 'MI', 'MN', 'MS', 'MO',
    'MT', 'NE', 'NV', 'NH', 'NJ',
    'NM', 'NY', 'NC', 'ND', 'OH',
    'OK', 'OR', 'PA', 'RI', 'SC',
    'SD', 'TN', 'TX', 'UT', 'VT',
    'VA', 'WA', 'WV', 'WI', 'WY'
  ];

  private readonly paidStates = new Set([
    'CA', 'CO', 'CT', 'DE', 'ME',
    'MD', 'MA', 'MN', 'NJ', 'NY',
    'OR', 'RI', 'WA', 'DC'
  ]);

  private readonly stateNames: Record<string, string> = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming'
  };

  canContinue = false;

  constructor(
    private readonly router: Router,
    private readonly zone: NgZone,
    private readonly botService: AskQuestionService
  ) {
    this.company_id = localStorage.getItem('company_id');
    this.user_id = localStorage.getItem('user_id');

    // Initialize every state to zero.
    this.stateCodes.forEach(code => {
      this.documentCounts[code] = 0;
    });
  }

  ngAfterViewInit(): void {

    const object = this.usaSvg.nativeElement;

    object.addEventListener('load', () => {
      this.onSvgLoad();
    });

    if (object.contentDocument) {
      this.onSvgLoad();
    }
  }


  onSvgLoad(): void {

    const object = this.usaSvg.nativeElement;
    const svgDoc = object.contentDocument;

    if (!svgDoc) {
      console.error('Unable to load USA SVG');
      return;
    }

    // Remove previously injected styles.
    svgDoc
      .querySelector('#dynamic-state-style')
      ?.remove();

    svgDoc
      .querySelectorAll('.dynamic-state-label')
      .forEach(label => label.remove());

    this.addMapStyles(svgDoc);
    this.initializeStates(svgDoc);
    this.createStateLabels(svgDoc);

    // Load real document availability.
    this.loadStateAvailability();

    console.log('USA state map initialized');
  }

  //   private addMapStyles(svgDoc: Document): void {

  //     svgDoc
  //       .querySelector('#dynamic-state-style')
  //       ?.remove();

  //     const style = svgDoc.createElementNS(
  //       'http://www.w3.org/2000/svg',
  //       'style'
  //     );

  //     style.id = 'dynamic-state-style';

  //     style.textContent = `

  //   /* =====================================================
  //      DEFAULT STATE - NO DOCUMENTS
  //   ===================================================== */

  //   path.state.no-documents {
  //     fill: #e5e7eb !important;
  //     stroke: #cbd5e1 !important;
  //     stroke-width: 1.2;
  //     cursor: pointer;
  //     filter: none;
  //   }


  //   /* =====================================================
  //      DOCUMENT AVAILABLE
  //      Paid OR Non-Paid
  //   ===================================================== */

  //   path.state.has-documents {
  //     fill: #8fa8d8 !important;
  //     stroke: #253b80 !important;
  //     stroke-width: 2;
  //     cursor: pointer;
  //   }


  //   /* =====================================================
  //      DOCUMENT AVAILABLE HOVER
  //   ===================================================== */

  //   path.state.has-documents:hover {
  //     fill: #6f8bc3 !important;
  //     stroke: #253b80 !important;
  //     stroke-width: 2.4;

  //     filter:
  //       drop-shadow(
  //         0 4px 8px
  //         rgba(37, 59, 128, 0.25)
  //       );
  //   }


  //   /* =====================================================
  //      SELECTED
  //   ===================================================== */

  //   path.state.selected {
  //     fill: #253b80 !important;
  //     stroke: #ffffff !important;
  //     stroke-width: 2.8;
  //     cursor: pointer;

  //     filter:
  //       drop-shadow(
  //         0 4px 8px
  //         rgba(37, 59, 128, 0.35)
  //       );
  //   }


  //   path.state.selected:hover {
  //     fill: #1d2f68 !important;
  //     stroke: #ffffff !important;
  //   }


  //   /* =====================================================
  //      LABEL
  //   ===================================================== */

  //   text.dynamic-state-label {
  //     fill: #64748b;
  //     font-family: Arial, Helvetica, sans-serif;
  //     font-size: 9px;
  //     font-weight: 700;

  //     text-anchor: middle;
  //     dominant-baseline: middle;

  //     pointer-events: none;
  //     user-select: none;

  //     paint-order: stroke;
  //     stroke: #ffffff;
  //     stroke-width: 2px;
  //   }


  //   /* Document available */
  //   text.dynamic-state-label.has-documents {
  //     fill: #253b80;
  //     font-weight: 800;
  //   }


  //   /* No documents */
  //   text.dynamic-state-label.no-documents {
  //     fill: #94a3b8;
  //   }


  //   /* Selected */
  //   text.dynamic-state-label.selected {
  //     fill: #ffffff !important;
  //     font-size: 10px;
  //     font-weight: 800;

  //     stroke: #253b80;
  //     stroke-width: 1.5px;
  //   }

  // `;

  //     svgDoc.documentElement.appendChild(style);
  //   }

  private addMapStyles(svgDoc: Document): void {

    svgDoc
      .querySelector('#dynamic-state-style')
      ?.remove();

    const style = svgDoc.createElementNS(
      'http://www.w3.org/2000/svg',
      'style'
    );

    style.id = 'dynamic-state-style';

    style.textContent = `

  /* =====================================================
     DEFAULT STATE - NO DOCUMENTS
  ===================================================== */

  path.state.no-documents {
    fill: #E5E7EB !important;
    stroke: #CBD5E1 !important;
    stroke-width: 1.2;
    cursor: pointer;
    filter: none;
  }

  path.state.no-documents:hover {
    fill: #D1D5DB !important;
    stroke: #94A3B8 !important;
  }


  /* =====================================================
     DOCUMENT AVAILABLE - NON PAID
  ===================================================== */

  path.state.has-documents {
    fill: #a7b5e1 !important;
    stroke: #eef2ff !important;
    stroke-width: 2;
    cursor: pointer;
  }

  path.state.has-documents:hover {
    fill: #253B80 !important;
    stroke: #eef2ff !important;
    stroke-width: 2.4;

    filter:
      drop-shadow(
        0 4px 8px
        rgba(37, 99, 235, 0.25)
      );
  }


  /* =====================================================
   PAID
===================================================== */

path.state.paid {
  fill: #253B80 !important;
  stroke: #1D2F68 !important;
  stroke-width: 2;
  cursor: pointer;
}

path.state.paid:hover {
  fill: #1D2F68 !important;
  stroke: #14224F !important;
  stroke-width: 2.4;

  filter:
    drop-shadow(
      0 4px 8px
      rgba(37, 59, 128, 0.30)
    );
}


/* =====================================================
   PAID LABEL
===================================================== */

text.dynamic-state-label.paid {
  fill: #253B80;
  font-weight: 800;
}

  /* =====================================================
     SELECTED
  ===================================================== */

  path.state.selected {
    fill: #253B80 !important;
    stroke: #FFFFFF !important;
    stroke-width: 2.8;
    cursor: pointer;

    filter:
      drop-shadow(
        0 4px 8px
        rgba(37, 59, 128, 0.35)
      );
  }

  path.state.selected:hover {
    fill: #1D2F68 !important;
    stroke: #FFFFFF !important;
  }


  /* =====================================================
     LABEL
  ===================================================== */

  text.dynamic-state-label {
    fill: #64748B;

    font-family:
      Arial,
      Helvetica,
      sans-serif;

    font-size: 9px;
    font-weight: 700;

    text-anchor: middle;
    dominant-baseline: middle;

    pointer-events: none;
    user-select: none;

    paint-order: stroke;
    stroke: #FFFFFF;
    stroke-width: 2px;
  }


  /* =====================================================
     DOCUMENT AVAILABLE LABEL
  ===================================================== */

  text.dynamic-state-label.has-documents {
    fill: #253B80;
    font-weight: 800;
  }


  /* =====================================================
     PAID LABEL
  ===================================================== */

  text.dynamic-state-label.paid {
  fill: #253B80;
  font-weight: 800;
}

  /* =====================================================
     NO DOCUMENT LABEL
  ===================================================== */

  text.dynamic-state-label.no-documents {
    fill: #94A3B8;
  }


  /* =====================================================
     SELECTED LABEL
  ===================================================== */

  text.dynamic-state-label.selected {
    fill: #FFFFFF !important;

    font-size: 10px;
    font-weight: 800;

    stroke: #253B80;
    stroke-width: 1.5px;
  }

  `;

    svgDoc.documentElement.appendChild(style);
  }

  private initializeStates(svgDoc: Document): void {

    const paths = svgDoc.querySelectorAll<SVGPathElement>('path');

    paths.forEach(state => {

      const code = state.id?.trim().toUpperCase();

      if (!code || !this.isUsState(code)) {
        return;
      }

      state.classList.add('state');

      this.updateStateClass(state, code);

      state.addEventListener('click', () => {

        this.zone.run(() => {

          const normalizedCode =
            code.trim().toUpperCase();

          const documentCount =
            this.documentCounts[normalizedCode] ?? 0;

          // No documents = disabled
          if (documentCount <= 0) {
            return;
          }

          // Paid OR non-paid can now be selected
          this.selectState(
            normalizedCode,
            svgDoc
          );

        });

      });

      state.addEventListener('mouseleave', () => {

        this.zone.run(() => {

          this.hoveredStateCode = '';

          this.updateHoverText();

        });

      });

    });
  }

  private updateHoverText(): void {

    // Nothing selected
    if (!this.selectedStateCode) {
      this.hoverState = '';
      return;
    }

    // All states selected
    if (this.selectedStateCode === 'all') {
      this.hoverState = 'All States';
      return;
    }

    // Normal selected state
    this.hoverState = this.getStateStatusText(
      this.selectedStateCode
    );
  }

  private selectState(
    code: string,
    svgDoc: Document
  ): void {

    const normalizedCode =
      code.trim().toUpperCase();

    const count =
      this.documentCounts[normalizedCode] ?? 0;


    // =====================================================
    // ONLY REQUIREMENT:
    // DOCUMENTS MUST EXIST
    // =====================================================

    if (count <= 0) {
      return;
    }


    // =====================================================
    // REMOVE PREVIOUS SELECTION
    // =====================================================

    svgDoc
      .querySelectorAll('path.state.selected')
      .forEach(element => {
        element.classList.remove('selected');
      });

    svgDoc
      .querySelectorAll(
        'text.dynamic-state-label.selected'
      )
      .forEach(element => {
        element.classList.remove('selected');
      });


    // =====================================================
    // SELECT STATE
    // =====================================================

    const statePath =
      svgDoc.querySelector<SVGPathElement>(
        `path#${normalizedCode}`
      );

    statePath?.classList.add('selected');


    // =====================================================
    // SELECT LABEL
    // =====================================================

    const label =
      svgDoc.querySelector<SVGTextElement>(
        `text.dynamic-state-label[data-state="${normalizedCode}"]`
      );

    label?.classList.add('selected');


    // =====================================================
    // ANGULAR STATE
    // =====================================================

    this.selectedStateCode =
      normalizedCode;

    this.selectedState =
      this.stateNames[normalizedCode] ??
      normalizedCode;

    this.hoverState =
      this.getStateStatusText(
        normalizedCode
      );


    // =====================================================
    // LOAD DOCUMENTS
    // =====================================================

    this.loadStateDocuments(
      normalizedCode
    );
  }

  private getStateStatusText(code: string): string {

    const count =
      this.documentCounts[code] ?? 0;

    const name =
      this.stateNames[code] ?? code;

    return count > 0
      ? `${name} · ${count} document${count === 1 ? '' : 's'}`
      : `${name} · No documents`;
  }

  private loadStateAvailability(): void {

    const payload = {

      offset: 0,

      limit: 1000,

      search: this.search ?? '',

      company_id: this.company_id,

      user_id: this.user_id,

      is_doc_section: true,

      state_code: 'all'

    };


    this.botService
      .getMessageAttachments(payload)
      .subscribe({

        next: (response: any) => {

          const documents =
            this.extractDocuments(response);


          // =================================================
          // RESET COUNTS
          // =================================================

          this.stateCodes.forEach(
            code => {

              this.documentCounts[code] = 0;

            }
          );


          // =================================================
          // COUNT DOCUMENTS
          // =================================================

          documents.forEach(
            (doc: any) => {

              const stateCode =
                String(
                  doc?.policy_state ??
                  doc?.state_code ??
                  doc?.state ??
                  ''
                )
                  .trim()
                  .toUpperCase();


              if (
                this.isUsState(
                  stateCode
                )
              ) {

                this.documentCounts[
                  stateCode
                ]++;

              }

            }
          );


          // =================================================
          // REFRESH MAP
          // =================================================

          this.refreshStateAvailability();


          // =================================================
          // CLEAR SELECTION
          // =================================================

          this.selectedStateCode = '';
          this.selectedState = '';
          this.hoverState = '';

          this.stateDocuments = [];

          this.canContinue = false;

        },


        error: (error: any) => {

          console.error(
            'Failed to load state availability:',
            error
          );


          this.stateCodes.forEach(
            code => {

              this.documentCounts[code] = 0;

            }
          );


          this.refreshStateAvailability();


          this.selectedStateCode = '';
          this.selectedState = '';
          this.hoverState = '';

          this.stateDocuments = [];

          this.canContinue = false;

        }

      });
  }

  private extractDocuments(
    response: any
  ): any[] {

    if (Array.isArray(response?.recordList)) {
      return response.recordList;
    }

    if (Array.isArray(response?.data)) {
      return response.data;
    }

    if (
      Array.isArray(
        response?.data?.recordList
      )
    ) {
      return response.data.recordList;
    }

    if (
      Array.isArray(
        response?.data?.data
      )
    ) {
      return response.data.data;
    }

    return [];
  }

  private createStateLabels(svgDoc: Document): void {

    const paths =
      svgDoc.querySelectorAll<SVGPathElement>('path');

    const offsets: Record<
      string,
      { x: number; y: number }
    > = {

      AL: { x: 0, y: 1 },
      AK: { x: 0, y: 0 },
      AZ: { x: 1, y: 1 },
      AR: { x: 0, y: 1 },
      CA: { x: 2, y: 3 },
      CO: { x: 0, y: 1 },
      CT: { x: 0, y: 1 },
      DE: { x: 1, y: 1 },
      FL: { x: 2, y: 3 },
      GA: { x: 1, y: 1 },
      HI: { x: 0, y: 0 },
      ID: { x: 0, y: 1 },
      IL: { x: 1, y: 1 },
      IN: { x: 1, y: 1 },
      IA: { x: 0, y: 1 },
      KS: { x: 0, y: 1 },
      KY: { x: 0, y: 1 },
      LA: { x: 1, y: 2 },
      ME: { x: 0, y: 1 },
      MD: { x: 0, y: 1 },
      MA: { x: 0, y: 1 },
      MI: { x: 1, y: 1 },
      MN: { x: 0, y: 1 },
      MS: { x: 0, y: 1 },
      MO: { x: 0, y: 1 },
      MT: { x: 0, y: 1 },
      NE: { x: 0, y: 1 },
      NV: { x: 1, y: 1 },
      NH: { x: 0, y: 1 },
      NJ: { x: 1, y: 1 },
      NM: { x: 1, y: 2 },
      NY: { x: 0, y: 1 },
      NC: { x: 0, y: 1 },
      ND: { x: 0, y: 1 },
      OH: { x: 0, y: 1 },
      OK: { x: 0, y: 1 },
      OR: { x: 0, y: 1 },
      PA: { x: 0, y: 1 },
      RI: { x: 1, y: 1 },
      SC: { x: 1, y: 1 },
      SD: { x: 0, y: 1 },
      TN: { x: 0, y: 1 },
      TX: { x: 0, y: 3 },
      UT: { x: 0, y: 1 },
      VT: { x: 0, y: 1 },
      VA: { x: 0, y: 1 },
      WA: { x: 0, y: 2 },
      WV: { x: 0, y: 1 },
      WI: { x: 0, y: 1 },
      WY: { x: 0, y: 1 }

    };

    paths.forEach(state => {

      const code =
        state.id
          ?.trim()
          .toUpperCase();

      if (!code || !this.isUsState(code)) {
        return;
      }

      let bbox: DOMRect;

      try {
        bbox = state.getBBox();
      } catch {
        return;
      }

      let x =
        bbox.x +
        bbox.width / 2;

      let y =
        bbox.y +
        bbox.height / 2;

      const offset =
        offsets[code];

      if (offset) {
        x += offset.x;
        y += offset.y;
      }

      const text =
        svgDoc.createElementNS(
          'http://www.w3.org/2000/svg',
          'text'
        );

      text.setAttribute(
        'x',
        x.toString()
      );

      text.setAttribute(
        'y',
        y.toString()
      );

      text.setAttribute(
        'class',
        'dynamic-state-label'
      );

      text.setAttribute(
        'data-state',
        code
      );

      text.textContent = code;

      this.updateLabelClass(
        text,
        code
      );

      svgDoc.documentElement.appendChild(text);

    });
  }

  private updateStateClass(
    state: SVGPathElement,
    code: string
  ): void {

    const normalizedCode =
      code.trim().toUpperCase();

    state.classList.remove(
      'paid',
      'has-documents',
      'no-documents',
      'selected'
    );

    const count =
      this.documentCounts[normalizedCode] ?? 0;


    // =====================================================
    // DOCUMENT STATUS
    // Applies to BOTH paid and non-paid states
    // =====================================================

    if (count > 0) {

      state.classList.add(
        'has-documents'
      );

    } else {

      state.classList.add(
        'no-documents'
      );

    }


    // =====================================================
    // PAID MARKER
    // Keep this if you still need paid-specific logic
    // =====================================================

    if (this.paidStates.has(normalizedCode)) {
      state.classList.add('paid');
    }


    // =====================================================
    // SELECTED
    // =====================================================

    if (
      this.selectedStateCode === normalizedCode ||
      (
        this.selectedStateCode === 'all' &&
        count > 0
      )
    ) {

      state.classList.add('selected');

    }
  }

  private updateLabelClass(
    label: SVGTextElement,
    code: string
  ): void {

    const normalizedCode =
      code.trim().toUpperCase();

    const count =
      this.documentCounts[normalizedCode] ?? 0;

    label.classList.remove(
      'paid',
      'has-documents',
      'no-documents'
    );

    if (this.paidStates.has(normalizedCode)) {
      label.classList.add('paid');
    }

    label.classList.add(
      count > 0
        ? 'has-documents'
        : 'no-documents'
    );
  }


  private refreshStateAvailability(): void {

    const svgDoc =
      this.usaSvg.nativeElement.contentDocument;

    if (!svgDoc) {
      return;
    }

    svgDoc
      .querySelectorAll<SVGPathElement>('path.state')
      .forEach(state => {

        const code =
          state.id
            ?.trim()
            .toUpperCase();

        if (!code || !this.isUsState(code)) {
          return;
        }

        this.updateStateClass(
          state,
          code
        );
      });

    svgDoc
      .querySelectorAll<SVGTextElement>(
        'text.dynamic-state-label'
      )
      .forEach(label => {

        const code =
          label
            .getAttribute('data-state')
            ?.trim()
            .toUpperCase();

        if (!code || !this.isUsState(code)) {
          return;
        }

        this.updateLabelClass(
          label,
          code
        );
      });
  }

  private isUsState(code: string | null | undefined): boolean {
    if (!code) {
      return false;
    }

    return this.stateCodes.includes(
      code.trim().toUpperCase()
    );
  }

  loadStateDocuments(stateCode: string): void {

    const normalizedStateCode =
      stateCode.trim().toUpperCase();

    if (!this.isUsState(normalizedStateCode)) {
      this.stateDocuments = [];
      this.canContinue = false;
      return;
    }

    this.isDocumentsLoading = true;
    this.canContinue = false;
    this.stateDocuments = [];

    const payload = {
      offset: this.offset ?? 0,
      limit: 1000,
      search: this.search ?? '',
      company_id: this.company_id,
      user_id: this.user_id,
      is_doc_section: true,
      state_code: normalizedStateCode
    };

    this.botService
      .getMessageAttachments(payload)
      .subscribe({

        next: (response: any) => {

          const documents =
            this.extractDocuments(response);

          this.stateDocuments =
            documents.filter((doc: any) => {

              const documentState =
                String(
                  doc?.policy_state ??
                  doc?.state_code ??
                  doc?.state ??
                  ''
                )
                  .trim()
                  .toUpperCase();

              return documentState === normalizedStateCode;

            });

          // Update count
          this.documentCounts[normalizedStateCode] =
            this.stateDocuments.length;

          // Enable Continue only when documents exist
          this.canContinue =
            this.stateDocuments.length > 0;

          this.isDocumentsLoading = false;

          // Refresh map colors
          this.refreshStateAvailability();

        },

        error: (error: any) => {

          console.error(
            `Failed to load documents for ${normalizedStateCode}:`,
            error
          );

          this.stateDocuments = [];

          this.documentCounts[normalizedStateCode] = 0;

          this.canContinue = false;

          this.isDocumentsLoading = false;

          this.refreshStateAvailability();

        }

      });
  }


  selectAllStates(): void {

    const svgDoc =
      this.usaSvg.nativeElement
        .contentDocument;

    if (!svgDoc) {
      return;
    }


    // Remove previous selections
    svgDoc
      .querySelectorAll(
        'path.state.selected'
      )
      .forEach(state => {

        state.classList.remove(
          'selected'
        );

      });


    svgDoc
      .querySelectorAll(
        'text.dynamic-state-label.selected'
      )
      .forEach(label => {

        label.classList.remove(
          'selected'
        );

      });


    // Select every state having documents
    this.stateCodes.forEach(
      code => {

        const count =
          this.documentCounts[code] ?? 0;


        if (count <= 0) {
          return;
        }


        const state =
          svgDoc.querySelector<SVGPathElement>(
            `path#${code}`
          );

        state?.classList.add(
          'selected'
        );


        const label =
          svgDoc.querySelector<SVGTextElement>(
            `text.dynamic-state-label[data-state="${code}"]`
          );

        label?.classList.add(
          'selected'
        );

      }
    );


    this.zone.run(() => {

      this.selectedStateCode = 'all';

      this.selectedState = 'All States';

      this.hoverState = 'All States';

      this.loadAllStateDocuments();

    });
  }

  loadAllStateDocuments(): void {

    this.isDocumentsLoading = true;
    this.stateDocuments = [];


    const payload = {

      offset: this.offset ?? 0,

      limit: 1000,

      search: this.search ?? '',

      company_id: this.company_id,

      user_id: this.user_id,

      is_doc_section: true,

      state_code: 'all'

    };


    this.botService
      .getMessageAttachments(payload)
      .subscribe({

        next: (response: any) => {

          this.stateDocuments =
            this.extractDocuments(
              response
            );


          this.canContinue =
            this.stateDocuments.length > 0;


          this.isDocumentsLoading = false;

        },


        error: (error: any) => {

          console.error(
            'Failed to load all state documents:',
            error
          );


          this.stateDocuments = [];

          this.canContinue = false;

          this.isDocumentsLoading = false;

        }

      });
  }

  continueToAskQuestion(): void {

    const stateCode =
      this.selectedStateCode?.trim().toUpperCase();

    console.log('Continue clicked:', {
      selectedStateCode: stateCode,
      selectedState: this.selectedState,
      documents: this.stateDocuments.length
    });


    // =====================================================
    // NO STATE SELECTED
    // =====================================================

    if (!stateCode) {
      return;
    }


    // =====================================================
    // ALL STATES
    // =====================================================

    if (stateCode === 'ALL') {

      if (this.stateDocuments.length <= 0) {
        return;
      }

      this.router.navigate(
        ['/askquestions'],
        {
          queryParams: {
            state: 'all'
          }
        }
      );

      return;
    }


    // =====================================================
    // STATE MUST HAVE DOCUMENTS
    // Paid OR Non-Paid is allowed
    // =====================================================

    const documentCount =
      this.documentCounts[stateCode] ?? 0;

    if (documentCount <= 0) {
      return;
    }


    // =====================================================
    // NAVIGATE
    // =====================================================

    this.router.navigate(
      ['/askquestions'],
      {
        queryParams: {
          state: stateCode
        }
      }
    ).then(
      success => {

        console.log(
          'Navigation result:',
          success
        );

      },
      error => {

        console.error(
          'Navigation failed:',
          error
        );

      }
    );
  }


  showDocumentModal = false;
  // selectedDocument: any = null;
  // selectedState = '';

  viewDocument(document: any, state?: string): void {
    this.selectedDocument = document;
    this.selectedState = state || this.selectedState || '';
    this.showDocumentModal = true;

    this.isSelectFileType = document.file_type;

    this.selectedReadFile = document.view_url ?? '';

    console.log(document, '::::::::::::document:::::::::::::');


    // document.body.classList.add('document-modal-open');
  }

  closeDocumentModal(): void {
    this.showDocumentModal = false;
    this.selectedDocument = null;

    // document.body.classList.remove('document-modal-open');
  }

  openDocument(document: any): void {

    console.log(document, '------------document');


    if (!document?.fileUrl) {
      return;
    }

    window.open(document.fileUrl, '_blank', 'noopener,noreferrer');
  }

  downloadDocument(document: any): void {
    if (!document?.fileUrl) {
      return;
    }

    const link = document.createElement('a');
    link.href = document.fileUrl;
    link.target = '_blank';
    link.download = document.fileName || document.title || 'document';

    link.click();
  }
}
